<script setup lang="ts">
import BaseSvg from '@clovyr/bed/components/icons/BaseSvg.vue';
</script>

<template>
  <BaseSvg class="icon icon-privacy-lock" width="28" height="28" viewBox="0 0 28 28" fill="none">
    <path
      stroke="#33e672"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.78"
      d="M9.5 12.56V7.68a4.88 4.88 0 0 1 4.88-4.88v0a4.88 4.88 0 0 1 4.88 4.88v4.88"
    />
    <path
      fill="#33e672"
      stroke="#33e672"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.78"
      d="M23.16 12.56H5.6v11.7h17.56v-11.7Z"
    />
  </BaseSvg>
</template>
